export const user = {
  create: () => ["CREATE_USER"] as const,
  login: () => ["LOGIN"] as const,
};
